import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getAccountDocumentListData } from './mockData'
import type { IAccountDocument } from '~/types/document/models'

export const {
  getDocuments: getAccountDocuments,
  postDocument: postAccountDocument,
  patchDocument: patchAccountDocument,
  deleteDocument: deleteAccountDocument,
  handlers,
} = makeDocumentAPIs<IAccountDocument>({
  apiPathEntityNamePrefix: 'account',
  getDocumentListDataFn: getAccountDocumentListData,
})
